import React from "react"

export default ({ crumbs = [{ name: 'Content | Editor', link: '/content-editor' }] }) => {
    return (
        <h1>{ crumbs.map(({ name, link }, index) => index != crumbs.length - 1 ? <React.Fragment key={index}><a href={link}>{ name }</a> ></React.Fragment> : <a key={index} href={link}>{ name }</a> ) }</h1>
    )
}